import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { __API_URL__ } from "../SERVER_URL";

const fetchPreviousEcrfsVisits = async ({ trialId, patientId, ecrfModelId }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (!!patientId) params.append("patient_id", patientId);
  if (!!trialId) params.append("trial_id", trialId);
  if (!!ecrfModelId) params.append("ecrf_model_id", ecrfModelId);

  const URL = `${__API_URL__}/api/ecrf/get_previous_ecrfs_visits/?${params.toString()}`;

  const res = await axios.get(URL, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useGetPreviousEcrfsVisits = ({ trialId, patientId, ecrfModelId, enabled = true }) => {
  return useQuery({
    queryKey: ["previous_ecrfs_visits", trialId, patientId, ecrfModelId],
    queryFn: () => fetchPreviousEcrfsVisits({ trialId, patientId, ecrfModelId }),
    enabled:
      enabled &&
      Boolean(trialId && trialId > 0) &&
      Boolean(patientId && patientId > 0) &&
      Boolean(ecrfModelId && ecrfModelId > 0),
  });
};

export default useGetPreviousEcrfsVisits;
